<template>
  <v-dialog 
    v-model="display"
    width="650"
    @click:outside="() => $emit('exit')"
  >
    <v-card 
    > 
      <v-container>
        <v-row>
          <v-col cols="12">
            <h3>Job Information</h3>
          </v-col>
        </v-row>
        <hr>
        <br>
        <v-row>
          <v-col cols="3" class="title">Title :</v-col>
          <v-col cols="8">{{ job.name }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="title">Description :</v-col>
          <v-col cols="8">{{ job.description }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="title">Assignee :</v-col>
          <v-col cols="8">{{ job.assigned_to }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="title">Created On :</v-col>
          <v-col cols="8">{{ formateCreatedDate(job.created_on) }}</v-col>
        </v-row>
      
        <div 
          v-if="isInstallTask"
          class="task-information"
        >
          <br>
          <hr>
          <br>
          <v-row>
            <v-col cols="12">
              <h3>Task Information</h3>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class="title">Name :</v-col>
            <v-col cols="8">{{ taskName }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class="title">Description :</v-col>
            <v-col cols="8">{{ taskDesc }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class="title">Action :</v-col>
            <v-col cols="8">{{ taskAction }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class="title">Number :</v-col>
            <v-col cols="8">{{ deviceCount }}</v-col>
          </v-row>

          <v-row v-for="(code) in pending_otcs" :key="code" class="font-weight-black">
            <v-col cols="3" class="title">OTC :</v-col>
            <v-col cols="8">{{ code }}</v-col>
          </v-row>

          <v-row
            v-for="(tag) in installation_tags"
            :key="tag.id"
          >
            <v-col cols="3" class="title">Destination :</v-col>
            <v-col cols="8" class="text-disable">
            {{tag.vehicle_name ? tag.install_tag + ' => ' +tag.vehicle_name : tag.install_tag}}</v-col>
          </v-row>

        </div>
        
        <br>
        <hr>
        <v-row>
          <v-col>
            <v-btn 
              text
              color="red" 
              @click="$emit('exit')">
              close
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import moment from "moment"

export default {
  name: 'ReadOnlyJob',
  props: {
    job: {
      type: Object,
      required: true
    },
    display: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isInstallTask() {
      return this.job.Tasks.length > 0 ? true : false;
    },
    installation_tags() {
      if (!this.job.Tasks[0].context.devices) return [];
      const installation_tags = this.job.Tasks[0].context.devices; //.map(

      return installation_tags;
    },
    pending_otcs() {
      if (!this.job.Tasks[0].pending_otcs) return [];
      const pending_otcs = this.job.Tasks[0].pending_otcs;

      return pending_otcs;
    },
    taskAction() {
      let action = this.job.Tasks[0].task_type;

      return action == 'taskinstall' ? 'Install' : 'Firmware Update';
    },
    deviceCount() {
      let count = this.job.Tasks[0].num_devices;

      return count;
    },
    taskName() {
      let name = this.job.Tasks[0].name;

      return name;
    },
    taskDesc() {
      let desc = this.job.Tasks[0].description;

      return desc;
    }
  },
  methods: {
    formateCreatedDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    }
  }
}
</script>

<style lang="scss" scoped>
</style>